import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import DashLayout from '../../components/DashLayout';

const nav = [
  { to: '/super-admin', icon: '📊', label: 'Dashboard' },
  { to: '/super-admin/businesses', icon: '🏢', label: 'Businesses' },
  { to: '/super-admin/payments', icon: '💰', label: 'Payments' },
  { to: '/super-admin/invoice-report', icon: '🧾', label: 'Invoice Report' },
  { to: '/super-admin/tickets', icon: '🎫', label: 'Support Tickets' },

  { to: '/super-admin/plans', icon: '📦', label: 'Plans' },
  { to: '/super-admin/agents', icon: '👥', label: 'Agent Requests' }
];

export default function SuperAdminPlans() {
  const [plans, setPlans] = useState([]);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = () => axios.get('/api/super-admin/plans').then(r => setPlans(r.data.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    setLoading(true);
    try {
      await axios.put(`/api/super-admin/plans/${editing.plan_key}`, editing);
      toast.success('Plan updated successfully!');
      setEditing(null);
      load();
    } catch { toast.error('Update failed'); } finally { setLoading(false); }
  };

  const toggle = (k) => setEditing(e => ({ ...e, [k]: e[k] ? 0 : 1 }));

  return (
    <DashLayout navItems={nav} role="Super Admin">
      <div style={{ padding: 28 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4 }}>Plan Settings</h1>
        <p style={{ color: '#555', fontSize: 13, marginBottom: 28 }}>Edit pricing, limits and features for all plans. Changes apply immediately.</p>

        {editing && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.9)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: 24 }}>
            <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 16, padding: 28, width: '100%', maxWidth: 560, maxHeight: '90vh', overflowY: 'auto' }}>
              <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 20, color: '#00d55b' }}>Edit: {editing.plan_name}</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                {[['Plan Name', 'plan_name', 'text'], ['USD Monthly', 'price_monthly_usd', 'number'], ['USD Yearly', 'price_yearly_usd', 'number'], ['INR Monthly', 'price_monthly_inr', 'number'], ['INR Yearly', 'price_yearly_inr', 'number'], ['Max Agents', 'max_agents', 'number'], ['Max Chats/Month', 'max_chats_per_month', 'number'], ['History Days', 'chat_history_days', 'number'], ['Max Websites', 'max_websites', 'number']].map(([label, key, type]) => (
                  <div key={key}>
                    <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 5 }}>{label}</label>
                    <input type={type} value={editing[key] || ''} onChange={e => setEditing(f => ({ ...f, [key]: type === 'number' ? (e.target.value === '' ? null : Number(e.target.value)) : e.target.value }))} placeholder={key.includes('month') || key.includes('day') ? 'null = unlimited' : ''} />
                  </div>
                ))}
              </div>
              <div style={{ marginTop: 16, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                {[['AI Chatbot', 'has_ai'], ['Custom Branding', 'has_custom_branding'], ['Analytics', 'has_analytics'], ['Canned Replies', 'has_canned_replies'], ['White Label', 'has_white_label'], ['API Access', 'has_api_access'], ['Ad Platform Integration', 'has_ads_integration']].map(([label, key]) => (
                  <div key={key} onClick={() => toggle(key)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#0d0d0d', borderRadius: 8, padding: '10px 12px', cursor: 'pointer' }}>
                    <span style={{ fontSize: 13, color: '#888' }}>{label}</span>
                    <div style={{ width: 38, height: 20, borderRadius: 10, background: editing[key] ? '#00d55b' : '#333', position: 'relative', transition: 'background 0.2s' }}>
                      <div style={{ position: 'absolute', top: 2, left: editing[key] ? 20 : 2, width: 16, height: 16, borderRadius: '50%', background: '#fff', transition: 'left 0.2s' }} />
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ display: 'flex', gap: 12, marginTop: 20 }}>
                <button onClick={() => setEditing(null)} style={{ flex: 1, padding: '11px', background: '#1a1a1a', border: '1px solid #1e1e1e', color: '#fff', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>Cancel</button>
                <button onClick={save} disabled={loading} style={{ flex: 2, padding: '11px', background: '#00d55b', color: '#000', borderRadius: 8, fontWeight: 700, cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
                  {loading ? 'Saving...' : '✓ Save Changes'}
                </button>
              </div>
            </div>
          </div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20 }}>
          {plans.map(p => (
            <div key={p.plan_key} style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 12, padding: 20 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
                <h3 style={{ fontSize: 16, fontWeight: 700, color: '#00d55b' }}>{p.plan_name}</h3>
                <button onClick={() => setEditing({ ...p })} style={{ padding: '5px 12px', background: '#1a1a1a', border: '1px solid #1e1e1e', color: '#888', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>Edit</button>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {[['USD Monthly', `$${p.price_monthly_usd}`], ['USD Yearly', `$${p.price_yearly_usd}/mo`], ['INR Monthly', `₹${Number(p.price_monthly_inr).toLocaleString()}`], ['INR Yearly', `₹${Number(p.price_yearly_inr).toLocaleString()}/mo`], ['Max Agents', p.max_agents], ['Chats/Month', p.max_chats_per_month ?? 'Unlimited'], ['History', p.chat_history_days ? `${p.chat_history_days} days` : 'Forever'], ['Max Websites', p.max_websites ?? 5]].map(([k, v]) => (
                  <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #0d0d0d' }}>
                    <span style={{ fontSize: 12, color: '#555' }}>{k}</span>
                    <span style={{ fontSize: 12, color: '#fff', fontWeight: 500 }}>{v}</span>
                  </div>
                ))}
              </div>
              <div style={{ marginTop: 14, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {[['AI', p.has_ai], ['Branding', p.has_custom_branding], ['Analytics', p.has_analytics], ['Canned', p.has_canned_replies], ['White Label', p.has_white_label], ['API', p.has_api_access], ['Ads', p.has_ads_integration]].map(([label, val]) => (
                  <span key={label} style={{ fontSize: 10, padding: '2px 8px', borderRadius: 20, background: val ? 'rgba(0,213,91,0.1)' : '#1a1a1a', color: val ? '#00d55b' : '#333' }}>{label}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </DashLayout>
  );
}